import styled from "styled-components";

export const ContainerModalConsultaSalida = styled.div`
  width: 452px;
  height: 216px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  flex-direction: column;
  /* position: absolute; */
  span,
  div {
    width: 90%;
  }
  span {
    font-size: 16px;
    font-weight: 800;
    white-space: 10px;
    color: var(--color-latex10);
  }

  button {
    width: 138px;
    height: 44px;
    border-radius: 8px;
    margin: 20px;
    font-weight: bold;
    color: var(--color-white);
    font-size: 16px;
    cursor: pointer;
  }
  .danger {
    background-color: var(--color-danger);
  }
  .success {
    background-color: var(--color-broccoli);
  }
`;

export const HeaderModal = styled.div`
  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  padding: 20px 20px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  .cierreModal {
    right: 20px;
    top: 20px;
    position: absolute;
    display: block;
    height: 16px;
    width: 16px;
  }
`;
